













import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { SzgcFormGetor } from "@/index";

@Component({
  name: "FinishFormPage",
  components: {
    SzgcFormGetor
  }
})
export default class FinishFormPage extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  private runTimeFields!: any;

  private flowData: any = null;
  private formConfig: any = {
    auths: "",
    formRenderData: "",
    results: "",
    pacId: "",
    businessId: "",
    businessName: "",
    reqToken: ""
  };
  private reqToken: string = "";

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.flowData = JSON.parse(JSON.stringify(newVal));
      this.reqToken = this.flowData.reqToken;
      this.formConfig = {
        ...this.flowData,
        auths: this.flowData.auths,
        formRenderData: this.flowData.formRender,
        results: this.flowData.fields,
        pacId: this.flowData.pacId,
        businessId: this.flowData.businessId,
        businessName: this.flowData.businessName,
        reqToken: this.reqToken
      };
    }
  }
}
